// extracted by mini-css-extract-plugin
export default {"btn":"ThemeBtn_btn__5SlPB","dark":"ThemeBtn_dark__-duvO"};